import FixtureAlertHeader from './fixtureAlertHeader.component';

export * from './fixtureAlertHeader.types';
export default FixtureAlertHeader;
